const StateJS = require('@steelbreeze/state');
const EventEmitter = require('events').EventEmitter;
const Enum = require('./enums');
const Event = require('./events');

/*
 * Definition for type : AntiStall
 */

function AntiStall(name, root) {
  this.bus = (root === null) ? new EventEmitter() : root.bus;
  this.name = name;
  this.root = (root === null) ? this : root;
  this.ready = false;

  this.build(name);
}

AntiStall.prototype.build = function (session) {
  /* State machine (states and regions) */
  /* Building root component */
  this._statemachine = new StateJS.State('default_statemachine');
  const _initial_AntiStall = new StateJS.PseudoState('_initial', this._statemachine, StateJS.PseudoStateKind.Initial);
  const AntiStall_null_Idle = new StateJS.State('Idle', this._statemachine);
  const AntiStall_null_Check = new StateJS.State('Check', this._statemachine).entry(() => {
    this.AntiStall_null_Check_videoData_var = this.computeVideoData();
    this.AntiStall_null_Check_currentTime_var = this.computeCurrentTime();
    this.bus.emit('timer', new Event.Timer_start_TimerMsgs(this.name, 'timer', this.AntiStall_workTimerId_var, this.AntiStall_checkIntervalMs_var));
  }).exit(() => {
    const currentVideoData_var = this.computeVideoData();
    const currentCurrentTime_var = this.computeCurrentTime();
    if ((currentCurrentTime_var - this.AntiStall_null_Check_currentTime_var < 0.1) || (this.compareTwoVideoData(currentVideoData_var, this.AntiStall_null_Check_videoData_var) === 0)) {
      this.bus.emit('antistall', new Event.Stalled_AntiStallMsg(this.name, 'antistall'));
    } else {
      this.bus.emit('antistall', new Event.Running_AntiStallMsg(this.name, 'antistall'));
    }
  });
  _initial_AntiStall.to(AntiStall_null_Idle);
  AntiStall_null_Check.to(AntiStall_null_Idle).on(Event.Stop_AntiStallMsg).when((stop) => stop.port === 'antistall' && stop.type === 'stop').effect((stop) => {
    this.bus.emit('timer', new Event.Timer_cancel_TimerMsgs(this.name, 'timer', this.AntiStall_workTimerId_var));
  });
  AntiStall_null_Idle.to(AntiStall_null_Check).on(Event.Start_AntiStallMsg).when((start) => start.port === 'antistall' && start.type === 'start');
  AntiStall_null_Check.to(AntiStall_null_Check).on(Event.Timer_timeout_TimerMsgs).when((timer_timeout) => timer_timeout.port === 'timer' && timer_timeout.type === 'timer_timeout' && (timer_timeout.id === this.AntiStall_workTimerId_var));
  this._statemachine.on(Event.VideoElement).when((videoElement) => videoElement.port === 'html5VideoElement' && videoElement.type === 'videoElement').effect((videoElement) => {
    this.AntiStall_video_var = videoElement.video;
  });
};
AntiStall.prototype.isInternetExplorer = function () {
  return (typeof window.document.documentMode === 'number');
};

AntiStall.prototype.computeVideoData = function () {
  if (this.AntiStall_video_var === undefined) {
    return;
  }
  const videoWidth_var = (this.AntiStall_video_var.videoWidth || 0);
  const videoHeight_var = (this.AntiStall_video_var.videoHeight || 0);
  if (videoWidth_var === 0 || videoHeight_var === 0) {
    return;
  }
  try {
    let canvas = document.createElement('canvas');
    canvas.width = videoWidth_var;
    canvas.height = videoHeight_var;
    const context = canvas.getContext('2d');
    context.drawImage(this.AntiStall_video_var, 0, 0, canvas.width, canvas.height);
    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    canvas = null;

    /* eslint-disable consistent-return */

    return imageData ? imageData.data : undefined;

    /* eslint-enable consistent-return */
  } catch (error) {
    console.error(error);
  }
};

AntiStall.prototype.compareTwoVideoData = function (AntiStall_compareTwoVideoData_a_var, AntiStall_compareTwoVideoData_b_var) {
  if ((!AntiStall_compareTwoVideoData_a_var)) {
    if ((!AntiStall_compareTwoVideoData_b_var)) {
      return 0;
    }
    return -1;
  }
  if ((!AntiStall_compareTwoVideoData_b_var)) {
    return 1;
  }
  const lengthDiff = AntiStall_compareTwoVideoData_a_var.length - AntiStall_compareTwoVideoData_b_var.length;
  if (lengthDiff !== 0) {
    return lengthDiff;
  }

  for (let i = 0, l = AntiStall_compareTwoVideoData_a_var.length; i < l; i += 1) {
    const diff = AntiStall_compareTwoVideoData_a_var[i] - AntiStall_compareTwoVideoData_b_var[i];
    if (diff !== 0) {
      return diff;
    }
  }
  return 0;
};

AntiStall.prototype.computeCurrentTime = function () {
  if (this.AntiStall_video_var === undefined) {
    return 0;
  }
  return (this.AntiStall_video_var.currentTime);
};

AntiStall.prototype._stop = function () {
  this.root = null;
  this.ready = false;
  this.stopped = true;
};

AntiStall.prototype._delete = function () {
  this._statemachine = null;
  this._null_instance = null;
  this.bus.removeAllListeners();
};

AntiStall.prototype._init = function () {
  this._null_instance = new StateJS.Instance('null_instance', this._statemachine);
  this.ready = true;
};

AntiStall.prototype._receive = function (msg) {
  if (this.ready) {
    this._null_instance.evaluate(msg);
  } else if (!this.stopped) {
    setTimeout(() => this._receive(msg), 4);
  }
};

AntiStall.prototype.toString = function () {
  let result = `instance ${this.name}:${this.constructor.name}\n`;
  result += `\n\tvideo = ${this.AntiStall_video_var}`;
  result += `\n\tcheckIntervalMs = ${this.AntiStall_checkIntervalMs_var}`;
  result += `\n\tcurrentTime = ${this.AntiStall_null_Check_currentTime_var}`;
  result += `\n\tvideoData = ${this.AntiStall_null_Check_videoData_var}`;
  result += `\n\tworkTimerId = ${this.AntiStall_workTimerId_var}`;
  result += '';
  return result;
};

module.exports = AntiStall;
